// extracted by mini-css-extract-plugin
export default {"buttonSkeleton":"ArtistPillLoadingSkeleton_buttonSkeleton__QdcO8","imageSkeleton":"ArtistPillLoadingSkeleton_imageSkeleton__5MsAy","pill":"ArtistPillLoadingSkeleton_pill__tarr3"};